<div class="loader__container">
	<mat-spinner
		[diameter]="144"
		[strokeWidth]="8"
	></mat-spinner>
	<p class="loader__heading">
		{{ loadingText }}
	</p>
</div>
